// 获取模版里的 head
function gethead(vm) {
  const { head } = vm.$options
  if (head) {
    return typeof head === 'function'
      ? head.call(vm)
      : head
  }
}

// 如果有 head 了就加载新的 head，没有就还有默认的顶着，默认的 head 在哪里，稍后告诉你
// 下面俩一个是服务器端渲染时调用，一个是客户端渲染是调用，为啥俩不一样，可查看文末知识点
var titleMore = '彭祖世家网Pengzushijia.com'
var descMore = '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，系彭祖世家文化发展有限公司与武汉聚脉网络科技有限公司合作，基于聚脉网络旗下国家发明专利技术产品“大谱师-互联网家谱协作编纂平台”进行品牌定制，专属服务全球彭氏族群编纂《彭祖世家总谱-事典》总谱、家族谱、家庭谱的互联网家谱协作编纂平台。'
var keywordMore = '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，彭祖,彭城,彭氏,彭姓,彭氏家谱,彭氏宗谱,彭氏族谱,彭祖世家,彭氏修谱,门户网站'

const serverheadMixin = {
  created() {
    const head = gethead(this)
    if (head) {
      if (head.title) {
        this.$ssrContext.title = `${head.title}`
      } else {
        this.$ssrContext.title = titleMore
      }
      if (head.mateDesc) {
        this.$ssrContext.mateDesc = `${head.mateDesc}`
      } else {
        this.$ssrContext.mateDesc = descMore
      }
      if (head.keys) {
        this.$ssrContext.keys = `${head.keys}`
      } else {
        this.$ssrContext.keys = keywordMore
      }
      if (head.bodystyle) {
        this.$ssrContext.bodystyle = `${head.bodystyle}`
      }
    }
  }
}

const clientheadMixin = {
  mounted() {
    const head = gethead(this)
    if (head) {
      if (head.title) {
        document.title = `${head.title}`
      } else {
        document.title = titleMore
      }
      if (head.mateDesc) {
        document.mateDesc = `${head.mateDesc}`
      } else {
        document.mateDesc = descMore
      }
      if (head.keys) {
        document.keys = `${head.keys}`
      } else {
        document.keys = keywordMore
      }
      if (head.bodystyle) {
        document.bodystyle = `${head.bodystyle}`
      }
    }
  }
}

export default process.env.VUE_ENV === 'server'
  ? serverheadMixin
  : clientheadMixin
